import { render, staticRenderFns } from "./LicenseModuleCheckbox.vue?vue&type=template&id=30e46b4f&"
import script from "./LicenseModuleCheckbox.vue?vue&type=script&lang=ts&"
export * from "./LicenseModuleCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseModuleCheckbox.vue?vue&type=style&index=0&id=30e46b4f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
